module.exports = __webpack_public_path__ + "static/media/HCIM_Letter.4fbc1222.png";